export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["昨天"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["聊天"])}
}